import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaDynamicFormModel, SmBtnMetaModel, SmToggleModel } from "common/models/utility-models/meta-model";

export class TypesMetaModel extends FormMetaModel {
    constructor() {
        super('Add Type', ROUTE_PATH.typeGrid, ROUTE_PATH.addType, 3, '', false, '', 'd-flex align-items-center justify-content-center');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const type_name = new SmMetaInputModel(

            'type_name',
            'type_name',
            'input',
            true,
            'col-12 ',
            1,
            1,
            'Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Enter Type Name"

        );


        const isActive = new SmToggleModel(
            'isActive',
            'isActive',
            'toggle',
            false,
            'col-12 p-0 ',
            1,
            8,
            '',
            '',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false,


        );


        const categories = new SmMetaInputModel(
            'categories',
            'categories',
            'input',
            false,
            ' form-group col-12 col-md-10 ',
            1,
            1,
            '',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Enter category"

        );

        const showToggle: boolean = false;

        const buttons = {
            submit: new SmBtnMetaModel('Save Type', '', true, false, true, true),
            isFormControl: false,
        };
        return {
            formInfo,
            buttons,
            type_name,
            categories,
            isActive
        }
    }
}